// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthRedirectProcess_container__3BeAh","errorBox":"AuthRedirectProcess_errorBox__hguhm","tryBtn":"AuthRedirectProcess_tryBtn__2fJfW"};